import { type PathRouteProps } from "react-router-dom";

import { gql } from "@apollo/client";
import { LoadingSlide } from "@components/title-slide-view";
import { useNorthbeamQuery } from "@hooks/http";
import { type FetchFarmstandPurchaseAnalytics } from "@north-beam/nb-client-side";
import { metrics } from "@north-beam/nb-common";
import { MetricValue } from "@shared/metric-value";

function FarmstandPurchasesTable(props: PathRouteProps) {
  const { data, loading } = useNorthbeamQuery<FetchFarmstandPurchaseAnalytics>(
    FETCH_FARMSTAND_PURCHASE_ANALYTICS,
    {},
  );
  if (loading) {
    return <LoadingSlide />;
  }

  return (
    <div className="container pt-4">
      <div className="row mt-5">
        <h1>Farmstand Purchases</h1>
      </div>
      <div className="row">
        <div className="row col mt-3">
          <table className="table table-bordered bg-white">
            <thead className="thead-light">
              <tr>
                <th className="text-center th-sm" scope="col">
                  Date
                </th>
                <th scope="col" className="text-center th-sm">
                  Count
                </th>
                <th scope="col" className="text-center th-sm">
                  Spend
                </th>
                <th scope="col" className="text-center th-sm">
                  Overall Blended Cost per Unit
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.me?.farmstandPurchaseAnalytics?.map((analytics) => (
                <tr key={analytics.date}>
                  <td>{analytics.date}</td>
                  <td>{analytics.count}</td>
                  <td>
                    <MetricValue
                      as="span"
                      value={analytics.spend}
                      format={metrics.MetricTypes.CURRENCY}
                      precision="exact"
                    />
                  </td>
                  <td>
                    <MetricValue
                      as="span"
                      value={analytics.spend / analytics.count}
                      format={metrics.MetricTypes.CURRENCY}
                      precision="exact"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export const FETCH_FARMSTAND_PURCHASE_ANALYTICS = gql`
  query FetchFarmstandPurchaseAnalytics {
    me {
      id
      farmstandPurchaseAnalytics
    }
  }
`;

export default FarmstandPurchasesTable;
